import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';

export class CustomRouteReuseStrategy implements RouteReuseStrategy {
  private storedRoutes = new Map<string, DetachedRouteHandle>();

  // Decide to detach the route to store it for reuse
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    const path = this.getRouteKey(route);
    return !!route.routeConfig && (path === ':posId' || path === ':posId/:categoryId');
  }

  // Store the detached route handle
  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void {
    const key = this.getRouteKey(route);
    if (handle) {
      this.storedRoutes.set(key, handle);
    }
  }

  // Whether to attach an already-stored handle
  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    const key = this.getRouteKey(route);
    return this.storedRoutes.has(key);
  }

  // Retrieve the stored route to reuse
  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    const key = this.getRouteKey(route);
    return this.storedRoutes.get(key) || null;
  }

  // Decide when routes should be reused
  shouldReuseRoute(future: ActivatedRouteSnapshot, current: ActivatedRouteSnapshot): boolean {
    return future.routeConfig?.component === current.routeConfig?.component;
  }

  // Generate a unique route key for mapping purposes
  private getRouteKey(route: ActivatedRouteSnapshot): string {
    return route.pathFromRoot
      .map(r => r.url.map(segment => segment.path).join('/'))
      .filter(Boolean)
      .join('/');
  }
}
